// import swal from 'sweetalert2'
import Vue from 'vue'
import swal from 'sweetalert2'
// // import $ from 'jquery'
import axios from 'axios'
var $ = require('jquery')

/**
 * Vue.prototype.$api.downloadSurveyStatsAsExcel
 * @type {{loadExamQuestions: BaseApi.loadExamQuestions, loadExams: BaseApi.loadExams, hideIdle: BaseApi.hideIdle, loadParticipants: BaseApi.loadParticipants, archiveStats: BaseApi.archiveStats, setCredentials: BaseApi.setCredentials, checkCredentials: BaseApi.checkCredentials, loadSurveys: BaseApi.loadSurveys, removeUser: BaseApi.removeUser, resetCredentials: BaseApi.resetCredentials, loadQuestions: BaseApi.loadQuestions, loadSystemGroupList: BaseApi.loadSystemGroupList, loadExam: BaseApi.loadExam, boolValueOfExam: BaseApi.boolValueOfExam, downloadExamRankList: BaseApi.downloadExamRankList, loadHistory: BaseApi.loadHistory, calculateExam: BaseApi.calculateExam, downloadExamPointList: BaseApi.downloadExamPointList, loadTests: BaseApi.loadTests, saveSystemGroupRights: BaseApi.saveSystemGroupRights, loadQuestion: BaseApi.loadQuestion, loadParticipantsWithAnswers: BaseApi.loadParticipantsWithAnswers, onGetError: BaseApi.onGetError, loadStats: BaseApi.loadStats, showIdle: BaseApi.showIdle, loadGroup: BaseApi.loadGroup, downloadExamGroupList: BaseApi.downloadExamGroupList, downloadExamNotesAsExcel: BaseApi.downloadExamNotesAsExcel, loadSystemGroupRights: BaseApi.loadSystemGroupRights}}
 */
const BaseApi = {
  css: '',
  reqIndex: 0,
  /**
   * Vue.prototype.$api.getCredentials()
   * @returns {{fromURL: boolean, authorized: boolean, authToken: (*|string)}|*}
   */
  getCredentials () {
    return Vue.prototype.$api.credentials
  },
  getAuthToken () {
    return Vue.prototype.$api.getCredentials().authToken
  },
  debug (message, a, b, c, d) {
    if (Vue.prototype.$config.isDev) {
      console.log('', message, a, b, c, d)
    }
  },
  log (message, a, b, c, d) {
    if (Vue.prototype.$config.isDev) {
      console.log('', message, a, b, c, d)
    }
  },
  createUploadToken (data) {
    let token = data.klausurId + '_' + data.participantId + '_' + data.questionId + '_' + data.column + '_' + data.row
    return token
  },
  createTokenDataFromDecodedToken (data) {
    let arr = data.split('_')
    let res = {
      klausurId: arr[0],
      participantId: arr[1],
      questionId: arr[2],
      column: arr[3],
      row: arr[4]
    }
    return res
  },
  hexEncode (str) {
    var hex, i
    var result = ''
    for (i = 0; i < str.length; i++) {
      hex = str.charCodeAt(i).toString(16)
      result += ('000' + hex).slice(-4)
    }
    return result
  },
  hexDecode (str) {
    var j
    var hexes = str.match(/.{1,4}/g) || []
    var back = ''
    for (j = 0; j < hexes.length; j++) {
      back += String.fromCharCode(parseInt(hexes[j], 16))
    }
    return back
  },
  /**
   * Vue.prototype.$api.getJQuery()
   * @returns {d}
   */
  getJQuery () {
    return $
  },
  showIdle: function (cmp, cmd, txt) {
    Vue.prototype.$eventHub.$emit('OnIdle', [true, txt])
    if (cmp && cmd) {
      cmp.$nextTick(() => {
        cmd()
      })
    }
  },
  getHost: function () {
    return Vue.config.host
  },
  hideIdle: function () {
    Vue.prototype.$eventHub.$emit('OnIdle', false)
  },
  /**
   * @param klausurId
   * @param fnOk
   * @param fnFailed
   */
  downloadSurveyStatsAsExcel: function (klausurId, item, fnOk, fnFailed) {
    window.location.href = Vue.config.host + '/v2/export/' + klausurId + '/csv?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    fnOk()
  },
  createExamAsPDF: function (klausurId, fnOk, fnFailed) {
    var url = Vue.config.host + '/v2/export/' + klausurId + '/pdf?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        fnFailed(jqXHR, textStatus, ex)
      }
    })
  },

  createExamMusterAsPDF: function (klausurId, fnOk, fnFailed) {
    var url = Vue.config.host + '/v2/export/' + klausurId + '/pdf?isMuster=1&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        fnFailed(jqXHR, textStatus, ex)
      }
    })
  },

  createSurveyAsPDF: function (klausurId, fnOk, fnFailed) {
    var url = Vue.config.host + '/v2/export/' + klausurId + '/surveypdf?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        fnFailed(jqXHR, textStatus, ex)
      }
    })
  },
  downloadSurveyMusterAsPDF: function (klausurId, fnOk, fnFailed) {
    window.location.href = Vue.config.host + '/export/surveyMusterDirect/' + klausurId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    fnOk()
  },
  downloadSurveyAsPDF: function (klausurId, fnOk, fnFailed) {
    window.location.href = Vue.config.host + '/download/survey/' + klausurId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    fnOk()
  },
  downloadExamAsPDF: function (klausurId, fnOk, fnFailed) {
    window.location.href = Vue.config.host + '/download/exam/' + klausurId + '?&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    fnOk()
  },
  downloadExamNotesAsExcel: function (klausurId, item, fnOk, fnFailed) {
    window.location.href = Vue.config.host + '/v1/group/' + klausurId + '/xls?pdfLayout=' + item.layout + '&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    fnOk()
  },
  downloadExamGroupList: function (klausurId, item, fnOk, fnFailed) {
    window.location.href = Vue.config.host + '/v1/exam/' + klausurId + '/auswertung/exportGruppen?pdfLayout=' + item.layout + '&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    fnOk()
  },
  downloadExamPointList: function (klausurId, item, fnOk, fnFailed) {
    let url = Vue.config.host + '/v1/exam/' + klausurId + '/auswertung/exportPunkte?pdfLayout=' + item.layout + '&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    console.log(url, item)
    window.location.href = url
    fnOk()
  },
  downloadExamRankList: function (klausurId, item, fnOk, fnFailed) {
    window.location.href = Vue.config.host + '/v1/exam/' + klausurId + '/auswertung/exportRanklist?pdfLayout=' + item.layout + '&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    fnOk()
  },
  createParticipant: function (idKlausur, participant, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var url = Vue.config.host + '/v1/group/' + idKlausur + '/addParticipant?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      type: 'post',
      data: JSON.stringify(participant),
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        fnFailed(jqXHR, textStatus, ex)
      }
    })
  },
  saveParticipant: function (idKlausur, participant, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var url = Vue.config.host + '/v1/group/' + idKlausur + '/saveParticipant?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      type: 'post',
      data: JSON.stringify(participant),
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        fnFailed(jqXHR, textStatus, ex)
      }
    })
  },
  removeParticipantsFromGroup: function (idKlausur, itemArray, fnOk, fnFailed) {
    var url = Vue.config.host + '/v1/group/' + idKlausur + '/removeParticipants?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      type: 'post',
      data: {
        'participantIds': itemArray
      },

      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        fnFailed(jqXHR, textStatus, ex)
      }
    })
  },
  resetTANParticipantsFromGroup: function (idKlausur, itemArray, fnOk, fnFailed) {
    var url = Vue.config.host + '/v1/group/' + idKlausur + '/resetTANParticipantsFromGroup?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      type: 'post',
      data: {
        'participantIds': itemArray
      },

      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        fnFailed(jqXHR, textStatus, ex)
      }
    })
  },
  removeParticipantFromGroup: function (idKlausur, idParticipant, fnOk, fnFailed) {
    var itemArray = []
    itemArray.push(idParticipant)
    var url = Vue.config.host + '/v1/group/' + idKlausur + '/removeParticipants?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      type: 'post',
      data: {
        'participantIds': itemArray
      },

      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        fnFailed(jqXHR, textStatus, ex)
      }
    })
  },

  /**
   * /v1/status/survey/{id}
   * @param klausurId
   * @param fnOk
   * @param fnFailed
   */
  getPDFStatusOfSurvey: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/status/survey/' + klausurId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },

  getPDFStatusOfExam: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/status/exam/' + klausurId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },

  calculateExam: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/exam/' + klausurId + '/calculate?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  boolValueOfExam: function (str) {
    if (!str) return false
    return ('' + str).toLowerCase() === 'true'
  },
  /**
   * Add question array filled with question ids to given group id
   * @param klausurId
   * @param selection
   * @param fnOk
   * @param fnFailed
   */
  addQuestionToGroup: function (klausurId, selection, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    var url = Vue.config.host + '/v2/group/addQuestions/' + klausurId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = {
      itemIds: selection,
      klausurId: klausurId
    }
    Vue.prototype.$api.getJQuery().post(url, JSON.stringify(pd), function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  loadTests: function (filterData, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    var url = Vue.config.host + '/v2/group?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var myFilter = []
    if (filterData) {
      if (filterData.search) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.search,
          'field': 'Titel',
          'type': ''
        })
      }
      if (filterData.subject) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.subject,
          'field': 'subject1',
          'type': ''
        })
      }
      if (filterData.status) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.status,
          'field': 'KStat',
          'type': ''
        })
      }
      if (filterData.author) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.author,
          'field': 'Autor',
          'type': ''
        })
      }
    }
    var pd = {
      start: 0,
      limit: 50,
      page: 0,
      filter: myFilter
    }
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  closeGroup: function (idGroup, fnOk, fnFailed) {
    var cmp = this
    var url = Vue.config.host + '/v2/group/' + idGroup + '/close' + '?token=' + Vue.prototype.$api.getAuthToken()
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      type: 'get',

      success: function (data) {
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  openGroup: function (idGroup, fnOk, fnFailed) {
    var cmp = this
    var url = Vue.config.host + '/v2/group/' + idGroup + '/open' + '?token=' + Vue.prototype.$api.getAuthToken()
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      type: 'get',

      success: function (data) {
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  copyQuestions: function (id, newTitle, fnOk, fnFailed) {
    var url = Vue.config.host + '/v1/questions/' + id + '/clone' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = {
      source: id,
      newTitle: newTitle
    }
    var cmp = this
    Vue.prototype.$api.showIdle()
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  copyGroup: function (idKlausur, newTitle, fnOk, fnFailed) {
    var url = Vue.config.host + '/v1/group/' + idKlausur + '/clone' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = {
      source: idKlausur,
      newTitle: newTitle
    }
    var cmp = this
    Vue.prototype.$api.showIdle()
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  loadSurveys: function (filterData, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    var myFilter = []
    if (filterData) {
      if (filterData.search) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.search,
          'field': 'Titel',
          'type': ''
        })
      }
      if (filterData.subject) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.subject,
          'field': 'subject1',
          'type': ''
        })
      }
      if (filterData.status) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.status,
          'field': 'KStat',
          'type': ''
        })
      }
      if (filterData.author) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.author,
          'field': 'Autor',
          'type': ''
        })
      }
    }
    var pd = {
      start: 0,
      limit: 50,
      page: 0,
      filter: myFilter
    }
    var url = Vue.config.host + '/v2/survey?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  replaceAll: function (target, search, replacement) {
    return target.replace(new RegExp(search, 'g'), replacement)
  },
  deleteSubject: function (data, nOk, fnFailed) {
    Vue.prototype.$api.getJQuery().getJSON({
      url: Vue.config.host + '/v2/subject/delete',
      data: JSON.stringify(data),
      type: 'post',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        nOk(data)
      },
      error: function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      }
    })
  },
  createSubject: function (data, nOk, fnFailed) {
    Vue.prototype.$api.getJQuery().getJSON({
      url: Vue.config.host + '/v2/subject/create',
      data: JSON.stringify(data),
      type: 'post',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        nOk(data)
      },
      error: function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      }
    })
  },
  createNewGroup: function (questionData, nOk, fnFailed) {
    Vue.prototype.$api.getJQuery().getJSON({
      url: Vue.config.host + '/v2/group/create',
      data: JSON.stringify(questionData),
      type: 'post',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        nOk(data)
      },
      error: function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      }
    })
  },
  resetPassword: function (credits, nOk, fnFailed) {
    Vue.prototype.$api.getJQuery().getJSON({
      url: Vue.config.host + '/config/user/' + credits.guid + '/resetPassword',
      data: JSON.stringify(credits),
      type: 'post',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        nOk(data)
      },
      error: function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      }
    })
  },
  createNewQuestion: function (questionData, fnSuccess, fnError) {
    let url = Vue.config.host + '/v2/question/create'
    var params = {
      time: new Date().getTime(),
      token: Vue.prototype.$api.getCredentials().authToken
    }
    axios({
      method: 'post',
      url: url,
      params: params,
      data: JSON.stringify(questionData),
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      })
      .catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  deleteItem: function (id, fnSuccess, fnError) {
    Vue.prototype.$api.showIdle()
    let url = Vue.config.host + '/v2/question/delete/' + id
    var data = {
      ID_Item: id
    }
    // var cmp = this
    /*
    Vue.prototype.$api.getJQuery().ajax({
      'url': Vue.config.host + '/v2/question/delete/' + id,
      'type': 'DELETE',
      data: data,
      'success': function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      }
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
    */
    var params = {
      time: new Date().getTime(),
      token: Vue.prototype.$api.getCredentials().authToken
    }
    axios({
      method: 'DELETE',
      url: url,
      params: params,
      data: JSON.stringify(data),
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      })
      .catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  removeUser: function (id, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    let url = Vue.config.host + '/v2/system/user/' + id + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().ajax({
      'url': url,
      'type': 'DELETE',
      'success': function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      }
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  removeUserByGuid: function (guid, fnSuccess, fnError) {
    Vue.prototype.$api.showIdle()
    let url = Vue.config.host + '/v2/system/user/guid/' + guid + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    axios({
      method: 'delete',
      params: {},
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  loadSubjects: function (fnSuccess, fnError) {
    Vue.prototype.$api.showIdle()
    let url = Vue.config.host + '/v3/system/subjects?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    axios({
      method: 'get',
      params: {},
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }).catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  loadUser: function (fnOk, fnFailed) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/system/users?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  loadSystemGroupList: function (fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/system/group/list?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  /**
   *
   * @param idKlausur
   * @param idQuestion
   * @param fnOk
   * @param fnFailed
   */
  removeQuestionFromGroup: function (idKlausur, idQuestion, fnOk, fnFailed) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    var itemArray = []
    var url = Vue.config.host + '/v1/group/removeQuestions/' + idKlausur + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    itemArray.push(idQuestion)
    Vue.prototype.$api.getJQuery().getJSON({
      url: url,
      type: 'post',
      data: {
        'itemIds': itemArray
      },
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      }
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  saveOrderOfItems: function (groupId, orderArray, fnOk, fnFailed) {
    var pd = {'itemIds': orderArray, 'klausurId': groupId}
    var cmp = this
    Vue.prototype.$api.showIdle()
    var url = Vue.config.host + '/v3/group/reorder/' + groupId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().post(url, JSON.stringify(pd), function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
    /*
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
     */
  },
  deleteGroup: function (groupId, fnOk, fnFailed) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    var url = Vue.config.host + '/v1/group/' + groupId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'DELETE',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  saveSystemGroupRights: function (groupId, postData, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    var url = Vue.config.host + '/v2/system/config/groups/set/' + groupId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = postData
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        fnOk(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
    /*
    Vue.prototype.$api.getJQuery().post(Vue.config.host + '/v2/system/config/groups/set/' + groupId + '?time=' + new Date().getTime() + '&token=' + Vue.credentials.authToken, postData, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
     */
  },
  updateRight: function (groupId, item, fnSuccess, fnError) {
    Vue.prototype.$api.showIdle()
    let url = Vue.config.host + '/v2/system/config/groups/setAttribute/' + groupId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    let params = item
    axios({
      method: 'post',
      data: JSON.stringify(params),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      })
      .catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  loadSystemGroupRights: function (fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/system/config/groups/data?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  loadLastOpened: function (fnOk, fnFailed) {
    var pd = {}
    var cmp = this
    var url = Vue.config.host + '/v2/lastUsed/exam?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  loadExamOnline: function (fnOk, fnFailed) {
    var pd = {}
    var cmp = this
    var url = Vue.config.host + '/v2/lastUsed/exam?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  loadExams: function (filterData, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    var myFilter = []
    if (filterData) {
      if (filterData.search) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.search,
          'field': 'Titel',
          'type': ''
        })
      }
      if (filterData.subject) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.subject,
          'field': 'subject1',
          'type': ''
        })
      }
      if (filterData.status) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.status,
          'field': 'KStat',
          'type': ''
        })
      }
      if (filterData.author) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.author,
          'field': 'Autor',
          'type': ''
        })
      }
    }
    var pd = {
      start: 0,
      limit: 50,
      page: 0,
      filter: myFilter
    }
    var url = Vue.config.host + '/v2/exam?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  loadExam: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/exam/' + klausurId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      var group = data
      if (!group.ausdruck_Config) {
        group.ausdruck_Config = {}
      } else {
        group.ausdruck_Config = JSON.parse(group.ausdruck_Config)
      }
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  /**
   *
   * @param klausurId
   * @param fnOk
   * @param fnFailed
   */
  loadHistory: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/group/' + klausurId + '/history?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  loadGroupQuestions: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/group/' + klausurId + '/questions?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  setItemFixed: function (klausurId, idItem, fixed, fnOk, fnFailed) {
    var cmp = this
    var url = Vue.config.host + '/v2/group/' + klausurId + '/items/' + idItem + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = {
      fixed: fixed
    }
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  /**
   *     var pd = {
      fixed: fixed
      pdfHidden: false
    }
   * @param klausurId
   * @param idItem
   * @param pd
   * @param fnOk
   * @param fnFailed
   */
  setItemAttributes: function (klausurId, idItem, pd, fnOk, fnFailed) {
    var cmp = this
    var url = Vue.config.host + '/v2/group/' + klausurId + '/items/' + idItem + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnOk) {
          fnOk(data)
        }
      },
      error: function (jqXHR, textStatus, ex) {
        if (fnFailed) {
          Vue.prototype.$api.hideIdle()
          fnFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  loadExamQuestionsVariants: function (klausurId, fnOk, fnFailed) {
    // /v1/exam/" + examId + "/variant/questions
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/exam/' + klausurId + '/variant/questions?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  loadExamQuestionsVariant: function (klausurId, variantNr, fnOk, fnFailed) {
    // /v1/exam/" + examId + "/variant/questions
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/exam/' + klausurId + '/variant/' + variantNr + '/questions?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  loadExamQuestions: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/exam/' + klausurId + '/questions?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  /**
   *
   * @param klausurId
   * @param fnOk
   * @param fnFailed
   */
  loadParticipantsWithAnswers: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/group/' + klausurId + '/participantsWithAnswers?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  loadParticipantWithAnswers: function (klausurId, idParticipant, fnSuccess, fnError) {
    Vue.prototype.$api.showIdle()
    var url = Vue.config.host + '/v1/exam/' + klausurId + '/participant/' + idParticipant + '/answers?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    axios({
      method: 'get',
      params: {},
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }).catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  loadParticipantWithAnswersSmall: function (klausurId, idParticipant, fnSuccess, fnError) {
    Vue.prototype.$api.showIdle()
    var url = Vue.config.host + '/v1/exam/' + klausurId + '/participant/' + idParticipant + '/answers?time=' + new Date().getTime() + '&small=1&&token=' + Vue.prototype.$api.getCredentials().authToken
    axios({
      method: 'get',
      params: {},
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      })
      .catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  loadParticipants: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/group/' + klausurId + '/participants?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  onGetError: function (j, error, a, b, c) {
    Vue.prototype.$api.hideIdle()
    console.log(error, a, b, c)
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request)
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error)
    }
    swal(
      'Fehler ' + error.status,
      error.message,
      'error'
    )
  },
  getJPGURL: function (item, idKlausur) {
    var url = Vue.config.host + '/v1/image/' + item.Spalte + '/' + item.Zeile + '/' + idKlausur
    // + '?token=' + Vue.prototype.$api.getCredentials().authToken
    return url
  },
  getHexURL: function (item, idKlausur) {
    var url = Vue.config.host + '/v1/image/' + item.Spalte + '/' + item.Zeile + '/' + idKlausur
    // + '?token=' + Vue.prototype.$api.getCredentials().authToken
    console.log('url', url)
    return url
  },
  downloadExamPDF: function (pdfLayout, idKlausur) {
    var url = Vue.config.host + '/v2/export/exam/' + idKlausur + '?pdfLayout=' + pdfLayout + '&token=' + Vue.prototype.$api.getCredentials().authToken
    window.open(url, '_blank')
  },
  downloadExamAnswerPDF: function (pdfLayout, idKlausur) {
    var url = Vue.config.host + '/v2/export/answer/' + idKlausur + '?pdfLayout=' + pdfLayout + '&token=' + Vue.prototype.$api.getCredentials().authToken
    window.open(url, '_blank')
  },
  downloadExamAnswerMusterPDF: function (pdfLayout, idKlausur) {
    var url = Vue.config.host + '/v2/export/muster/' + idKlausur + '?pdfLayout=' + pdfLayout + '&token=' + Vue.prototype.$api.getCredentials().authToken
    window.open(url, '_blank')
  },
  previewPDF: function (pdfLayout, idKlausur) {
    var url = Vue.config.host + '/v2/export/group/' + idKlausur + '?pdfLayout=' + pdfLayout + '&token=' + Vue.prototype.$api.getCredentials().authToken
    window.open(url, '_blank')
  },
  loadGroup: function (id, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/group/' + id + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      for (var i in data.results) {
        var group = data.results[i]
        if (!group.ausdruck_Config) {
          group.ausdruck_Config = {}
        } else {
          group.ausdruck_Config = JSON.parse(group.ausdruck_Config)
        }
      }
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        Vue.prototype.$api.hideIdle()
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  saveGroup: function (questionData, onSuccess, onFailed) {
    var cmp = this
    var did = questionData.ID_Klausur
    if (!did) did = questionData.id
    var url = Vue.config.host + '/v2/group/save/' + did + '?target=group&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = JSON.parse(JSON.stringify(questionData))
    if (!pd.ausdruck_Config) {
      pd.ausdruck_Config = {}
    }
    pd.ausdruck_Config = JSON.stringify(pd.ausdruck_Config)
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        onSuccess(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (onFailed) {
          Vue.prototype.$api.hideIdle()
          onFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  saveExam: function (questionData, onSuccess, onFailed) {
    var cmp = this
    var did = questionData.ID_Klausur
    if (!did) did = questionData.id
    var url = Vue.config.host + '/v2/group/save/' + did + '?target=exam&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = JSON.parse(JSON.stringify(questionData))
    if (!pd.ausdruck_Config) {
      pd.ausdruck_Config = {}
    }
    pd.ausdruck_Config = JSON.stringify(pd.ausdruck_Config)
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        onSuccess(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (onFailed) {
          Vue.prototype.$api.hideIdle()
          onFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  savePrintLayout: function (questionData, onSuccess, onFailed) {
    return this.saveExamData('print', questionData, onSuccess, onFailed)
  },
  saveExamData: function (target, questionData, onSuccess, onFailed) {
    var cmp = this
    var did = questionData.ID_Klausur
    if (!did) did = questionData.id
    var url = Vue.config.host + '/v2/group/save/' + did + '?target=' + target + '&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = JSON.parse(JSON.stringify(questionData))
    if (!pd.ausdruck_Config) {
      pd.ausdruck_Config = {}
    }
    pd.ausdruck_Config = JSON.stringify(pd.ausdruck_Config)
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        onSuccess(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (onFailed) {
          Vue.prototype.$api.hideIdle()
          onFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  saveQuestion: function (questionData, onSuccess, onFailed) {
    var cmp = this
    var url = Vue.config.host + '/v2/question/save/' + questionData.idItem + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var pd = questionData
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        onSuccess(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (onFailed) {
          Vue.prototype.$api.hideIdle()
          onFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  getPDFLayouts: function (idItem, onSuccess, onFailed) {
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/group/pdflayouts/' + idItem + '?authToken=' + Vue.prototype.$api.getAuthToken(), function (data) {
      Vue.prototype.$api.hideIdle()
      onSuccess(data)
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        console.log(error, a, b, c)
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
        }
        swal(
          'Fehler ' + error.status,
          error.message,
          'error'
        )
        if (onFailed) {
          onFailed()
        }
      })
  },
  loadVariantQuestionArchived: function (groupId, idItem, variantNr, onSuccess, onFailed) {
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/exam/question/' + groupId + '/' + idItem + '/' + variantNr + '?authToken=' + Vue.prototype.$api.getAuthToken(), function (data) {
      Vue.prototype.$api.hideIdle()
      onSuccess(data)
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        console.log(error, a, b, c)
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
        }
        swal(
          'Fehler ' + error.status,
          error.message,
          'error'
        )
        if (onFailed) {
          onFailed()
        }
      })
  },
  /*
  Diese Funktion ist obsolute da der Result nicht korrekt
  loadQuestionArchived: function (idItem, onSuccess, onFailed) {

    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/exam/question/read/' + idItem + '?authToken=' + Vue.prototype.$api.getAuthToken(), function (data) {
      Vue.prototype.$api.hideIdle()
      onSuccess(data)
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        console.log(error, a, b, c)
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
        }
        swal(
          'Fehler ' + error.status,
          error.message,
          'error'
        )
        if (onFailed) {
          onFailed()
        }
      })

  },
  */
  getQuestionConfig: function (id, zeile, spalte, onSuccess, onFailed) {
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/question/' + id + '/config/' + spalte + '/' + zeile + '?authToken=' + Vue.prototype.$api.getAuthToken(), function (data) {
      Vue.prototype.$api.hideIdle()
      onSuccess(data)
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        console.log(error, a, b, c)
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
        }
        swal(
          'Fehler ' + error.status,
          error.message,
          'error'
        )
        if (onFailed) {
          onFailed()
        }
      })
  },
  addQuestionCell: function (id, configData, fnSuccess, fnError) {
    var url = Vue.config.host + '/v2/question/' + id + '/addCell?authToken=' + Vue.prototype.$api.getAuthToken()
    var params = configData
    axios({
      method: 'post',
      data: JSON.stringify(params),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  setQuestionConfig: function (id, zeile, spalte, configData, onSuccess, onFailed) {
    var cmp = this
    var url = Vue.config.host + '/v2/question/' + id + '/config/' + spalte + '/' + zeile + '?authToken=' + Vue.prototype.$api.getAuthToken()
    var pd = configData
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        onSuccess(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (onFailed) {
          Vue.prototype.$api.hideIdle()
          onFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  removeQuestionCell: function (id, zeile, spalte, configData, onSuccess, onFailed) {
    var cmp = this
    var url = Vue.config.host + '/v2/question/' + id + '/remove/' + spalte + '/' + zeile + '?authToken=' + Vue.prototype.$api.getAuthToken()
    var pd = configData
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(pd),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        onSuccess(data)
      },
      error: function (jqXHR, textStatus, ex) {
        if (onFailed) {
          Vue.prototype.$api.hideIdle()
          onFailed(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  checkRightSubExists: function (subName, target) {
    var a = Vue.prototype.$api.checkRightExists('AllowMy' + target + 'To' + subName, 'AllowMy' + target.substring(0, target.length - 1) + 'To' + subName)
    var b = Vue.prototype.$api.checkRightExists('Allow' + target + 'To' + subName, 'Allow' + target.substring(0, target.length - 1) + 'To' + subName)
    var c = Vue.prototype.$api.checkRightExists('AllowForeign' + target + 'To' + subName, 'AllowForeign' + target.substring(0, target.length - 1) + 'To' + subName)
    console.log('r', a, b, c)
    return a || b || c
  },
  checkRightExists: function (name, alternateName) {
    var credits = this.getCredentials()
    if (credits.data.rights) {
      if (credits.data.rights[name]) {
        return credits.data.rights[name].enabled
      }
      if (alternateName && credits.data.rights[alternateName]) {
        return credits.data.rights[alternateName].enabled
      }
    }
    return false
  },
  validateRights: function (cmp, data, defData, fnSuccessRights, fnMisssingRights) {
    if (data) {
      if (data.success === false) {
        if ((data.message === 'missing rights') || (data.message === 'User not allowed')) {
          cmp.noRights = true
          cmp.noRightsData = data
          if (fnMisssingRights) {
            fnMisssingRights(cmp, data)
          }
          return defData
        }
      }
    }
    cmp.noRights = false
    cmp.noRightsData = null
    if (fnSuccessRights) fnSuccessRights(cmp, data)
    return data
  },
  loadQuestion: function (idItem, onSuccess, onFailed) {
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v2/question/read/' + idItem + '?authToken=' + Vue.prototype.$api.getAuthToken(), function (data) {
      Vue.prototype.$api.hideIdle()
      onSuccess(data)
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        console.log(error, a, b, c)
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
        }
        swal(
          'Fehler ' + error.status,
          error.message,
          'error'
        )
        if (onFailed) {
          onFailed()
        }
      })
  },
  loadQuestions: function (filterData, fnOk, fnFailed, page, rowsPerPage) {
    Vue.prototype.$api.showIdle()
    var myFilter = []
    if (filterData) {
      if (filterData.search) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.search,
          'field': 'frage',
          'type': ''
        })
      }
      if (filterData.subject) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.subject,
          'field': 'subject1',
          'type': ''
        })
      }
      if (filterData.status) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.status,
          'field': 'IStat',
          'type': ''
        })
      }
      if (filterData.author) {
        myFilter.push({
          'property': '',
          'value': '' + filterData.author,
          'field': 'Autor',
          'type': ''
        })
      }
      myFilter = JSON.stringify(myFilter)
    }
    if (!page) {
      page = 0
    }
    if (!rowsPerPage) {
      rowsPerPage = 50
    }
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/question?page=' + page + '&limit=' + rowsPerPage + '&filter=' + myFilter + '&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  archiveStats: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/exam/' + klausurId + '/auswertung/archive' + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  clearScanFolder (id, recognizeAllNew, fnSuccess, fnError) {
    var params = {
      'examId': id
    }
    if (recognizeAllNew) {
      params['jobType'] = 'clearScanFolder'
    } else {
      params['jobType'] = ''
    }
    Vue.prototype.$api.showIdle()
    Vue.prototype.$api.getJQuery().ajax({
      url: Vue.config.host + '/v1/exam/' + id + '/clearScanFolder?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken,
      data: params,
      type: 'POST',

      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,

      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)

          fnError(xhr, status, error)
        }
      }
    })
  },
  resetSystemUser (user, fnSuccess, fnError) {
    var url = Vue.config.host + '/v2/system/user/reset/' + user.id + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    let params = user
    axios({
      method: 'post',
      data: JSON.stringify(params),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  updateSystemUser (user, fnSuccess, fnError) {
    var url = Vue.config.host + '/v2/system/user/' + user.id + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    let params = user
    axios({
      method: 'post',
      data: JSON.stringify(params),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createSystemUser (doSendEmail, user, fnSuccess, fnError) {
    var url = Vue.config.host + '/v2/system/user'
    let params = {
      doSendEmail: doSendEmail,
      time: new Date().getTime(),
      token: Vue.prototype.$api.getCredentials().authToken
    }
    axios({
      method: 'post',
      params: params,
      data: JSON.stringify(user),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createRecogJob (id, recognizeAllNew, fnSuccess, fnError) {
    var params = {
      'examId': id
    }
    if (recognizeAllNew) {
      params['jobType'] = 'createRecog'
    } else {
      params['jobType'] = ''
    }
    var url = Vue.config.host + '/v1/exam/' + id + '/createRecognizeJob?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    axios({
      method: 'post',
      data: JSON.stringify(params),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  // /v1/exam/{idGroup}/scanFile
  getGroupScanFileUrl (id, fileName, fnSuccess, fnError) {
    var url = Vue.config.host + '/v1/exam/' + id + '/scanFile?fileName=' + encodeURIComponent(fileName) + '&time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    return url
  },
  barcodeStringToObject (barcode) {
    var result = {
      klausurId: -1,
      page: -1,
      variant: -1
    }
    if (!barcode) return result
    var bc = barcode.split('-')
    if (bc.length > 0) {
      result.klausurId = bc[0] * 1
    }
    if (bc.length > 1) {
      result.page = bc[1] * 1
    }
    if (bc.length > 2) {
      result.variant = bc[2] * 1
    }
    return result
  },
  stringToBoolean (str) {
    try {
      if (!str) return false
      if (str) {
        str = str.toLowerCase()
        if (str === 'false') return false
        if (str === 'true') return true
      }
    } catch (eee) {
    }
    return false
  },

// /v2/exam/{idGroup}/recog/{variantNr}
  getGroupVariantDefault (idGroup, variantNr, pageNr, fnSuccess, fnError) {
    var param = {
      time: new Date().getTime(),
      token: Vue.prototype.$api.getCredentials().authToken
    }
    var url = Vue.config.host + '/v2/exam/' + idGroup + '/recog/' + variantNr + '/' + pageNr
    axios({
      method: 'get',
      params: param,
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })

    /*
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: param,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'GET',
      headers: {
        'xes_api_key': 'examenis'
      },
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
    */
  },
  saveScanGroupJson (id, fileName, extData, fnSuccess, fnError) {
    // item.extData.ui.group = item.group
    // item.extData.ui.page = item.page
    // if (p) {
    // item.extData.ui.teilnehmerId = p.teilnehmerId
    // item.extData.ui.matrikel = p.matrikel
    //
    var data = {
      teilnehmerId: extData.ui.teilnehmerId,
      teilnehmerGroup: extData.ui.group,
      fileName: fileName,
      extData: JSON.stringify(extData)
    }
    Vue.prototype.$api.showIdle()
    var url = Vue.config.host + '/v1/exam/' + id + '/scanJSONData?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    var cmp = this
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'POST',
      success: function (data) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) fnSuccess(data)
      },
      error: function (jqXHR, textStatus, ex) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(jqXHR, textStatus, ex)
        } else {
          cmp.onGetError(this, jqXHR, textStatus, ex)
        }
      }
    })
  },
  getGroupScanFiles (id, fnSuccess, fnError) {
    var param = {
      taskId: 'hello',
      folder: 'data\\' + id + '\\scans'
    }
    // /v1/exam/{idGroup}/scans
    var url = Vue.config.host + '/v1/exam/' + id + '/scans?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: param,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'GET',
      headers: {
        'xes_api_key': 'examenis'
      },
      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
  },
  loadStats: function (klausurId, fnOk, fnFailed) {
    Vue.prototype.$api.showIdle()
    var cmp = this
    Vue.prototype.$api.getJQuery().get(Vue.config.host + '/v1/exam/' + klausurId + '/auswertung' + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
      Vue.prototype.$api.hideIdle()
      fnOk(data)
    }).catch(function (error, a, b, c) {
      if (fnFailed) {
        fnFailed(error)
      } else {
        cmp.onGetError(this, error, a, b, c, fnFailed)
      }
    })
  },
  setCredentials: function () {
    if (window.localStorage) {
      window.localStorage.credentials = JSON.stringify(Vue.prototype.$api.credentials)
    }
  },
  getFilterString: function (cmp) {
    var filterString = ''
    if (cmp.status) {
      filterString += ' Status: ' + cmp.tableUtils.getGroupStatusOfValue(cmp.status).name
    }
    if (cmp.author) {
      filterString += ' Author: ' + cmp.author
    }
    return filterString
  },
  resetCredentials: function (cmp) {
    if (window.localStorage) {
      window.localStorage.credentials = null
    }
    Vue.prototype.$eventHub.$emit('OnLogin', false)
    console.log('open login')
    cmp.$router.push('/Login')
  },
  checkCredentials: function (cmp) {
    if (cmp.$route.query.authToken) {
      Vue.prototype.$api.credentials = {
        'authorized': true,
        'fromURL': true,
        'authToken': cmp.$route.query.authToken
      }
      return
    }
    if (Vue.prototype.$api.credentials && Vue.prototype.$api.credentials.authorized) {
      return Vue.prototype.$api.credentials
    } else {
      if (window.localStorage && window.localStorage.credentials) {
        Vue.prototype.$api.credentials = JSON.parse(window.localStorage.credentials)
        if (Vue.prototype.$api.credentials && Vue.prototype.$api.credentials.authorized) {
          Vue.prototype.$eventHub.$emit('OnLogin', true)
          return Vue.prototype.$api.credentials
        }
        return null
      }
    }
    console.log('open login')
    cmp.$router.push('/Login')
    return null
  }
}
export default BaseApi



// WEBPACK FOOTER //
// ./src/api.js